module.exports = __webpack_public_path__ + "static/images/banner.6105396.png";